import React from 'react';

const IconMic = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M6 10.5a6 6 0 0 0 12 0" />
    <path d="M12 16.5V21" />
    <path d="M9 21h6" />
  </svg>
);

export default IconMic;